<template>
  <div>
    <div class="d-flex justify-center">
      <div class="py-8 px-9">
        <span class="heading-1">Edit Poll</span>
      </div>
    </div>
    <div style="margin: 0 8.9vw">
      <v-card
        class="my-6 pa-9"
        flat
        style="background-color: rgba(222, 227, 239, 1)"
      >
        <span class=""><b>Survey Title</b></span>
        <v-card class="mt-3" flat>
          <v-text-field
            class="pt-1"
            dense
            single-line
            outlined
            hide-details=""
          ></v-text-field>
        </v-card>
        <div class="mt-3">
          <span class=""><b>Survey Description</b></span>
        </div>
        <v-card class="mt-3" flat>
          <v-textarea
            class="pt-1"
            dense
            single-line
            outlined
            hide-details=""
            counter="100"
          ></v-textarea>
        </v-card>
          <div class="d-flex justify-end"> 0/115 character limit
          </div>
      </v-card>
    </div>

    <div style="margin: 0 8.9vw">
      <v-card
        class="my-6 pa-9"
        flat
        style="background-color: rgba(222, 227, 239, 1)"
      >
        <v-card flat style="background-color: rgba(222, 227, 239, 1)">
          <div class="">
            <div class="my-6">
              <div class="mt-5">
                <b class="d-flex justify-start"> Date Start </b>
              </div>
              <v-row>
                <v-col cols="12" md="7">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-card class="mt-3" flat>
                        <v-text-field
                          class="pt-1"
                          dense
                          single-line
                          outlined
                          hide-details=""
                          v-model="date"
                          label=""
                          append-icon="mdi-calendar-range-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </v-card>
                    </template>
                    <v-date-picker v-model="enddate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu2 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
            <div>
              <div class="my-3">
                <b class="mt-2"> Question 1 </b>
              </div>
            </div>
            <v-row class="">
              <v-col cols="12" md="6">
                <v-card flat>
                  <v-text-field
                    class="pt-1"
                    dense
                    single-line
                    label="Enter your Question"
                    outlined
                    hide-details=""
                  ></v-text-field>
                </v-card>
              </v-col>
              <v-col>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-card flat>
                      <v-text-field
                        v-model="formTemplate"
                        class="pt-1"
                        dense
                        single-line
                        label="Enter your Choice"
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        hide-details=""
                      ></v-text-field>
                    </v-card>
                  </template>
                  <v-list>
                    <v-list-item class="cursor-pointer">
                      <v-list-item-title @click="templateSelection('3')"
                        ><v-icon>mdi-checkbox-marked</v-icon>
                        <span class="ml-2">
                          Multiple choice
                        </span></v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item class="cursor-pointer">
                      <v-list-item-title @click="templateSelection('4')"
                        ><v-icon>mdi-radiobox-marked</v-icon>
                        <span class="ml-2">
                          Checkboxes
                        </span></v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item class="cursor-pointer">
                      <v-list-item-title @click="templateSelection('5')"
                        ><svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.501 9.5C18.471 9.5 17.601 10.12 17.211 11H14.291C13.901 10.12 13.031 9.5 12.001 9.5C10.971 9.5 10.101 10.12 9.71098 11H6.79098C6.40098 10.12 5.53098 9.5 4.50098 9.5C3.12098 9.5 2.00098 10.62 2.00098 12C2.00098 13.38 3.12098 14.5 4.50098 14.5C5.53098 14.5 6.40098 13.88 6.79098 13H9.71098C10.101 13.88 10.971 14.5 12.001 14.5C13.031 14.5 13.901 13.88 14.291 13H17.211C17.601 13.88 18.471 14.5 19.501 14.5C20.881 14.5 22.001 13.38 22.001 12C22.001 10.62 20.881 9.5 19.501 9.5Z"
                            fill="#080816"
                            fill-opacity="0.6"
                          />
                        </svg>

                        <span class="ml-2">
                          Linear scale
                        </span></v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <!-- <v-divider class="divider"></v-divider> -->
            <div class="px-9 pb-9">
              <div v-if="formTemplate === 'Short answer'">
                <v-text-field label="Short answer" single-line></v-text-field>
              </div>
              <div v-if="formTemplate === 'Paragraph'">
                <v-text-field label="Title" single-line></v-text-field>
                <v-textarea
                  label="Description (optional)"
                  single-line
                ></v-textarea>
              </div>
              <div v-if="formTemplate === 'Multiple choice'">
                <div class="mt-4">
                  <v-btn small block color="primary" @click="SaveCheckBox()">
                    Add Multiple choice</v-btn
                  >
                </div>
                <!-----------------add check box dialog--------------------------->
                <v-dialog
                  v-model="addCheckBoxDialog"
                  max-width="450"
                  persistent
                >
                  <v-card class="px-9 py-5">
                    <div class="d-flex justify-space-between">
                      <div><b>Edit Checkboxes</b></div>
                      <v-icon @click="addCheckBoxDialog = false"
                        >mdi-close</v-icon
                      >
                    </div>
                    <div>
                      <v-text-field
                        v-model="AddCheckBox"
                        label="Enter checkbox name"
                        single-line
                      ></v-text-field>
                    </div>
                    <div class="d-flex justify-end">
                      <v-btn
                        depressed
                        color="black"
                        text
                        outlined
                        class="mr-3"
                        @click="addCheckBoxDialog = false"
                        >cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="px-11"
                        depressed
                        @click="addCheckBoxDialog = false"
                        >Save</v-btn
                      >
                    </div>
                  </v-card>
                </v-dialog>
                <div>
                  <div class="mt-8" v-show="showmulilpecheckbox">
                    <div v-for="(item, i) in MultiCheckbox" :key="i">
                      <v-row class="d-flex align-center">
                        <v-col class="my-0 py-0">
                          <v-checkbox
                            v-model="QuestionCheckbox"
                            :value="item"
                            multiple
                            class="ma-0 pa-0"
                            hide-details
                          >
                            <template v-slot:label>
                              <div class="py-4 mt-3">
                                <span
                                  >Option <span>{{ i + 1 }} </span></span
                                >
                              </div>
                            </template>
                          </v-checkbox>
                        </v-col>
                        <v-col class="my-0 py-0">
                          <div class="d-flex justify-end">
                            <v-icon
                              class="mx-3"
                              @click="addCheckBoxDialog = true"
                              >mdi-pencil</v-icon
                            >
                            <v-icon @click="removeCheckBox(i + 1)"
                              >mdi-delete
                            </v-icon>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="d-flex justify-end py-6">
                      <v-btn
                        depressed
                        color="black"
                        text
                        outlined
                        class="mr-3"
                        @click="addCheckBoxDialog = false"
                        >cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="px-11"
                        depressed
                        @click="showQuestion()"
                        >Save</v-btn
                      >
                    </div>
                  </div>
                </div>
                <div class="mt-12" v-show="showquestionone">
                  <span class="font-26"
                    >Q-1 Take our free Fundamentally BodyTalk course
                  </span>
                  <v-container fluid>
                    <v-radio-group v-model="radios">
                      <v-radio value="Option1">
                        <template v-slot:label>
                          <div class="font-20 pl-2">Option 1</div>
                        </template>
                      </v-radio>
                      <v-radio value="Option2">
                        <template v-slot:label>
                          <div class="font-20 pl-2 mt-2">Option 1</div>
                        </template>
                      </v-radio>
                      <v-radio value="Option3">
                        <template v-slot:label>
                          <div class="font-20 pl-2 mt-2">Option 1</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <div class="d-flex justify-end">
                      <v-icon> mdi-delete </v-icon>
                    </div>
                  </v-container>
                </div>
              </div>

              <div v-if="formTemplate === 'Checkboxes'">
                <div class="mt-4">
                  <v-btn small block color="primary" @click="SaveCheckBox()">
                    Add checkbox</v-btn
                  >
                </div>
                <!-----------------add check box dialog--------------------------->
                <v-dialog
                  v-model="addCheckBoxDialog"
                  max-width="450"
                  persistent
                >
                  <v-card class="px-9 py-5">
                    <div class="d-flex justify-space-between">
                      <div class="h1">Edit Checkboxes</div>
                      <v-icon @click="addCheckBoxDialog = false"
                        >mdi-close</v-icon
                      >
                    </div>
                    <div>
                      <v-text-field
                        v-model="AddCheckBox"
                        label="Enter checkbox name"
                        single-line
                      ></v-text-field>
                    </div>
                    <div class="d-flex justify-end">
                      <v-btn
                        depressed
                        color="black"
                        text
                        outlined
                        class="mr-3"
                        @click="addCheckBoxDialog = false"
                        >cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="px-11"
                        depressed
                        @click="SaveRadiobutton()"
                        >Save</v-btn
                      >
                    </div>
                  </v-card>
                </v-dialog>
                <div>
                  <div class="mt-8" v-show="showmulilperadiobtton">
                    <div v-for="(item, i) in MultiCheckbox" :key="i">
                      <v-row class="d-flex align-center">
                        <v-col class="my-0 py-0">
                          <v-radio
                            v-model="QuestionCheckbox"
                            :value="item"
                            class="ma-0 pa-0"
                            hide-details
                          >
                            <template v-slot:label>
                              <div class="py-4 mt-3">
                                <span
                                  >Option <span>{{ i + 1 }} </span></span
                                >
                              </div>
                            </template>
                          </v-radio>
                        </v-col>
                        <v-col class="my-0 py-0">
                          <div class="d-flex justify-end">
                            <v-icon
                              class="mx-3"
                              @click="addCheckBoxDialog = true"
                              >mdi-pencil</v-icon
                            >
                            <v-icon @click="removeCheckBox(i)"
                              >mdi-delete
                            </v-icon>
                          </div>
                        </v-col>
                      </v-row>
                    </div>

                    <div class="d-flex justify-end py-6">
                      <v-btn
                        depressed
                        color="Black"
                        text
                        outlined
                        class="mr-3"
                        @click="addCheckBoxDialog = false"
                        >cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="px-11"
                        depressed
                        @click="SaveRadiobutton()"
                        >Save</v-btn
                      >
                    </div>
                  </div>
                  <div>
                    <div class="mt-5" v-show="showquestionTwo">
                      <span class="font-26"
                        >Q-2 Take our free Fundamentally BodyTalk course
                      </span>
                      <v-container>
                        <v-checkbox v-model="checkbox" class="mt-0 mb-0">
                          <template v-slot:label>
                            <div class="font-20">Option 1</div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="checkbox1" class="mt-0 mb-0">
                          <template v-slot:label>
                            <div class="font-20">Option 1</div>
                          </template>
                        </v-checkbox>
                        <v-checkbox v-model="checkbox2" class="mt-0 mb-0">
                          <template v-slot:label>
                            <div class="font-20">Option 1</div>
                          </template>
                        </v-checkbox>
                        <div class="d-flex justify-end">
                          <v-icon> mdi-delete </v-icon>
                        </div>
                      </v-container>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="formTemplate === 'Linear scale'">
                <div>
                  <div class="mt-8" v-show="showlinneroptions">
                    <v-row>
                      <v-col cols="6">
                        <div class="d-flex align-center mb-9">
                          <v-card class="py-1 pl-3 pr-1 mr-4" flat outlined
                            >1 <v-icon>mdi-chevron-down</v-icon></v-card
                          >
                          to
                          <v-card class="ml-4" max-width="60" flat>
                            <v-select
                              :items="linearItemCount"
                              dense
                              v-model="selectedLinearItem"
                              hide-details
                            ></v-select>
                          </v-card>
                        </div>
                        <div
                          v-for="item in parseInt(selectedLinearItem)"
                          :key="item"
                          class="d-flex align-center my-2"
                        >
                          <span class="mr-4"
                            ><b> {{ item }}. </b></span
                          >
                          <v-text-field
                            label="Label (optional)"
                            dense
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <div class="d-flex justify-end py-6">
                      <v-btn
                        depressed
                        color="black"
                        text
                        outlined
                        class="mr-3"
                        >cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        class="px-11"
                        depressed
                        @click="Savelinnerbutton()"
                        >Save</v-btn
                      >
                    </div>
                  </div>
                </div>

                <div>
                  <div class="mt-5" v-show="showquestionThree">
                    <span class="font-26"
                      >Q-3 Take our free Fundamentally BodyTalk course
                    </span>
                    <v-container fluid class="mt-0">
                      <v-radio-group
                        v-model="radioscourse"
                        class="small-radio mt-0"
                      >
                        <v-row>
                          <v-col cols="12" sm="2" md="2">
                            <span class="font-14 d-flex justify-center">1</span>
                            <v-radio
                              style="font-size: none"
                              class="mt-10 d-flex justify-center"
                              label=""
                              large
                              value="radio-1"
                            ></v-radio>
                            <span class="font-16 d-flex justify-center mt-6"
                              >Terrible
                            </span>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <span class="font-14 d-flex justify-center">2</span>
                            <v-radio
                              class="mt-10 d-flex justify-center v-icons"
                              label=""
                              value="radio-2"
                            ></v-radio>
                            <span class="font-16 d-flex justify-center mt-6"
                              >Bad
                            </span>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <span class="font-14 d-flex justify-center">3</span>
                            <v-radio
                              class="mt-10 d-flex justify-center"
                              label=""
                              value="radio-3"
                              style="font-size: 38px !important"
                            ></v-radio>
                            <span class="font-16 d-flex justify-center mt-6"
                              >Okay
                            </span>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <span class="font-14 d-flex justify-center">4</span>
                            <v-radio
                              class="mt-10 d-flex justify-center"
                              label=""
                              value="radio-4"
                            ></v-radio>
                            <span class="font-16 d-flex justify-center mt-6"
                              >Good
                            </span>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <span class="font-14 d-flex justify-center">5</span>
                            <v-radio
                              class="mt-10 d-flex justify-center v-icon"
                              label=""
                              value="radio-5"
                            ></v-radio>
                            <span class="font-16 d-flex justify-center mt-6"
                              >Great
                            </span>
                          </v-col>
                        </v-row>
                      </v-radio-group>
                      <div class="d-flex justify-end">
                        <v-icon> mdi-delete </v-icon>
                      </div>
                    </v-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
        <v-divider> </v-divider>
        <div class="d-flex justify-start">
          <v-btn color="primary" @click="addRow">
            <v-icon class="px-2"> mdi-plus-circle-outline </v-icon> NEW QUESTION
          </v-btn>
        </div>
        <div class="d-flex justify-end">
          <v-btn color="primary" depressed> Save Survey </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      div: 0,
      divs: [],
      showmulilpecheckbox: true,
      showmulilperadiobtton: true,
      showlinneroptions: true,
      linearItemCount: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      selectedLinearItem: "5",
      QuestionCheckbox: [],
      addCheckBoxDialog: false,
      AddCheckBox: "",
      showquestionone: false,
      showquestionTwo: false,
      showquestionThree: false,
      editcheckbox: false,
      formTemplate: "",
      MultiCheckbox: [],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
    };
  },
  methods: {
    addRow() {
      this.divs.push({
        div: this.div,
      });
    },
    // deleteRow(index) {
    //   this.divs.splice(index, 1);
    // },

    removeCheckBox(e) {
      this.MultiCheckbox = this.MultiCheckbox.filter((x, i) => i + 1 != e);
    },

    showQuestion() {
      this.showquestionone = true;
      this.showmulilpecheckbox = false;
      this.showquestionTwo = false;
      this.showquestionThree = false;
      this.showlinneroptions = false;
    },
    SaveRadiobutton() {
      this.showmulilperadiobtton = false;
      this.showquestionTwo = true;
      this.showquestionThree = false;
      this.showlinneroptions = false;
    },
    Savelinnerbutton() {
      this.showquestionTwo = false;
      this.showquestionone = false;
      this.showquestionThree = true;
      this.showlinneroptions = false;
    },
    SaveCheckBox() {
      this.MultiCheckbox.push(this.AddCheckBox);
    },
    templateSelection(e) {
      if (e === "1") {
        this.formTemplate = "Short answer";
      } else if (e === "2") {
        this.formTemplate = "Paragraph";
      } else if (e === "3") {
        this.formTemplate = "Multiple choice";
      } else if (e === "4") {
        this.formTemplate = "Checkboxes";
      } else if (e === "5") {
        this.formTemplate = "Linear scale";
         this.showlinneroptions = true;
      } else if (e === "6") {
        this.formTemplate = "Date";
      }
    },
  },
};
</script>

<style scoped>
.font-20 {
  font-size: 20px;
}
.main-heading {
  font-family: "Merriweather";
  font-size: 24px;
  font-weight: 400;
}
.h1 {
  font-family: "Lato";
  font-size: 18px;
  font-weight: 700;
}
.font-14 {
  font-size: 14px;
}
</style>
